import { CKAvatar } from '@clearkit/react';
import gravatarUrl from 'gravatar-url';

import TwoLineMenuItem from './TwoLineMenuItem';

const SalesforceLeadListItem = ({
  salesforceLead,
  salesforceAccountConnector,
}) => {
  return (
    <TwoLineMenuItem
      externalLinkClass="text-blue-500"
      href={`${salesforceAccountConnector.externalInstanceUrl}/${salesforceLead.externalId}`}
      icon={
        <CKAvatar
          src={gravatarUrl(salesforceLead.email)}
          size={32}
          className="shadow-sm"
        />
      }
      title={salesforceLead.name}
      subtitle={<>Owned by {salesforceLead?.owner?.name || 'Unknown User'}</>}
    />
  );
};

export default SalesforceLeadListItem;
